<template>
    <div class="app" data-app>
        <AppHeader fixed>
            <SidebarToggler class="d-lg-none" display="md" mobile />
            <b-link class="navbar-brand eb-navbar-brand" to="#">
                <span class="navbar-brand-full">
                    <img
                        src="@/assets/icon/whiteFastForge.svg"
                        class="navbar-brand-logo"
                    />
                </span>
                <span class="navbar-brand-minimized">{{ companyAlpa }}</span>
            </b-link>
            <SidebarToggler class="d-md-down-none" display="lg" />
            <b-navbar-nav class="d-md-down-none">
                <b-nav-item class="px-3">
                    <div class="app-search"></div>
                </b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto">
                <notificationbell></notificationbell>
            </b-navbar-nav>
            <b-navbar-nav>
                <DefaultHeaderDropdownAccnt />
            </b-navbar-nav>
        </AppHeader>
        <div class="app-body" v-if="$currentUserData">
            <AppSidebar fixed>
                <SidebarHeader />
                <SidebarForm />
                <SidebarNav :navItems="safeItems"></SidebarNav>
                <SidebarFooter />
                <SidebarMinimizer />
            </AppSidebar>
            <main class="main">
                <Breadcrumb :list="list" />
                <div class="container-fluid">
                    <router-view></router-view>
                </div>
            </main>
            <AppAside fixed>
                <!--aside-->
                <DefaultAside />
            </AppAside>
        </div>
        <TheFooter>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        2018 - 2025 ©
                        <a href>Trigital</a> - Nipige.com
                    </div>
                    <div class="col-md-6">
                        <div
                            class="text-md-right footer-links d-none d-md-block"
                        >
                            <a href="#" class="mr-2">About</a>
                            <a href="#" class="mr-2">Support</a>
                            <a href="#" class="mr-2">Contact Us</a>
                        </div>
                    </div>
                </div>
            </div>
        </TheFooter>
        <orderModal v-if="isShowModal"></orderModal>
    </div>
</template>

<script>
import nav from "@/_nav";
import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as TheFooter,
    Breadcrumb,
} from "@/components";
import orderModal from "@/components/OrderModal/OrderModal.vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import { mapActions } from "vuex";
import notificationbell from "@/components/Header/headerbell.vue";
export default {
    name: "DefaultContainer",
    components: {
        orderModal,
        notificationbell,
        AsideToggler,
        AppHeader,
        AppSidebar,
        AppAside,
        TheFooter,
        Breadcrumb,
        DefaultAside,
        DefaultHeaderDropdownAccnt,
        SidebarForm,
        SidebarFooter,
        SidebarToggler,
        SidebarHeader,
        SidebarNav,
        SidebarMinimizer,
    },
    data() {
        return {
            nav: nav.items,
            search: "",
            newMessageData: null,
            modalShow: false,
            companyAlpa: "N",
            companyName: "FASTFORGE",
        };
    },
    computed: {
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
        currentOrderData() {
            return this.$store.getters["notification/GetCurrentOrderDetails"];
        },
        isShowModal() {
            return this.$store.getters[
                "notification/GetNotificationModalState"
            ];
        },
        searchText: {
            get: function () {
                return this.search;
            },
            set: function (newVal) {
                this.$store.dispatch("product/search", newVal);
                this.search = newVal;
            },
        },
        name() {
            return this.$route.name;
        },
        list() {
            return this.$route.matched.filter(
                (route) => route.name || route.meta.label,
            );
        },
        safeItems: {
            get() {
                if (this.$currentUserData) {
                    const permissionsData = this.getParsedPermissions();
                    const filterNavTree = (navItem) => {
                        if (!navItem.auth) {
                            return navItem;
                        }
                        if (
                            navItem.auth.required &&
                            Array.isArray(navItem.auth.required) &&
                            permissionsData.hasPermission(navItem.auth.required)
                        ) {
                            if (navItem.children) {
                                navItem.children.filter(
                                    (x) => filterNavTree(x) !== null,
                                );
                            }
                            return navItem;
                        }
                        if (
                            navItem.auth.oneOf &&
                            Array.isArray(navItem.auth.oneOf) &&
                            permissionsData.hasPermission(navItem.auth.oneOf)
                        ) {
                            if (navItem.children) {
                                navItem.children.filter(
                                    (x) => filterNavTree(x) !== null,
                                );
                            }
                            return navItem;
                        }
                        return null;
                    };
                    return this.nav.filter((x) => filterNavTree(x) !== null);
                } else {
                    return [];
                }
            },
        },
    },
    methods: {
        ...mapActions({
            getPreference: "tenant/getTenantPreferences",
        }),
        getParsedPermissions() {
            const permissions = { ...this.$currentUserData.permissions };
            permissions.hasPermission = function (permissions) {
                if (!Array.isArray(permissions)) {
                    permissions = [permissions];
                }
                for (const p of permissions) {
                    if (this[p]) {
                        return true;
                    }
                }
                return false;
            };
            return permissions;
        },
        socketReconnect() {
            if (this.$currentUserData) {
                let userdata = this.$currentUserData;
                let object = {
                    uid: userdata._id,
                };
                // $socket is socket.io-client instance
                this.$socket.emit("adduser", object);
                this.$socket.emit("getunread", object);
            }
            this.sockets.subscribe("mymessage", (data) => {
                if (Array.isArray(data)) {
                    this.$store.dispatch(
                        "notification/setAllNotifications",
                        data,
                    );
                } else {
                    if (
                        data.message.type === "order-request" ||
                        data.message.type === "manufacturer-order-request"
                    ) {
                        this.$store.dispatch(
                            "notification/openNotificationModal",
                            true,
                        );
                        this.$store.dispatch(
                            "notification/setNewOrdersNotification",
                            data,
                        );
                        let orderLink =
                            this.$store.getters[
                                "notification/GetNewOrderNotification"
                            ];
                        this.$store.dispatch(
                            "notification/getOrderDetails",
                            orderLink["message"]["orderDetailsLink"],
                        );
                    }
                }
            });
        },
    },
    mounted() {
        if (this.$currentUserData) {
            this.initSocket();
            let userdata = this.$currentUserData;
            let object = {
                uid: userdata._id,
            };
            if (this.userRole === "Partner") {
                this.getPreference(userdata.tenant);
            } else if (this.userRole === "Tenant") {
                this.getPreference(userdata._id);
            }
            // $socket is socket.io-client instance
            this.$socket.emit("adduser", object);
            this.$socket.emit("getunread", object);
            if (this.sockets) {
                this.sockets.subscribe("mymessage", (data) => {
                    if (Array.isArray(data)) {
                        this.$store.dispatch(
                            "notification/setAllNotifications",
                            data,
                        );
                    } else {
                        if (
                            data.message.type === "order-request" ||
                            data.message.type === "manufacturer-order-request"
                        ) {
                            this.$store.dispatch(
                                "notification/openNotificationModal",
                                true,
                            );
                            this.$store.dispatch(
                                "notification/setNewOrdersNotification",
                                data,
                            );
                            let orderLink =
                                this.$store.getters[
                                    "notification/GetNewOrderNotification"
                                ];
                            this.$store.dispatch(
                                "notification/getOrderDetails",
                                orderLink["message"]["orderDetailsLink"],
                            );
                        }
                    }
                });
            }
        }
        const name = JSON.parse(sessionStorage.getItem("companyName"));
        this.companyName = name || "FASTFORGE";
        this.companyAlpa = name?.toUpperCase()?.slice(0, 1) || "N";
    },
    sockets: {
        connect: function () {},
        reconnect: function () {
            this.$socket.io.reconnect();
            this.socketReconnect();
        },
        disconnect: () => {},
    },
};
</script>

<style>
.eb-navbar {
    background: linear-gradient(135deg, #8b76de 0, #8178e7 60%);
    width: 200px;
    margin-left: -17px;
    height: 71px;
    margin-top: -15px;
}

.eb-navbar-brand {
    margin-left: -14px !important;
    margin-top: -7px !important;
}

.navbar-brand-logo {
    max-width: 100%;
    max-height: 100%;
    display: block;
    object-fit: contain;
}
.navbar-brand-full {
    display: inline-block;
    width: 160px;
}

@media (min-width: 992px) {
    .brand-minimized .app-header .navbar-brand {
        width: 50px !important;
        background-color: transparent;
        transition: 0.2s;
        transition-timing-function: linear;
    }
}

@media screen and (max-width: 992px) {
    .eb-navbar-brand {
        display: none !important;
    }
}

@media only screen and (max-width: 992px) {
    .app-search {
        display: block !important;
    }
}

@media (max-width: 575.98px) {
    .sidebar-show .main::before,
    .aside-menu-show .main::before {
        background: none !important;
    }
}

@media (min-width: 575.98px) {
    .header-fixed .app-header {
        position: fixed;
    }
}

@media (min-width: 200.98px) {
    .header-fixed .app-header {
        position: fixed;
    }
}
</style>
